module.exports = "/virtual-football-league/img/amblems/right/logos/BILBAO.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/BILBAO.png
// module id = 2158
// module chunks = 4